export const APP_VERSION = "3.5.0";
